import { Button, Result } from 'antd';
import { useUserContext } from 'features/users';
import { t } from 'i18next';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const ResultNoCompany = () => {
  const navigate = useNavigate();
  const { companyUser } = useUserContext(); // Access companyUser from context
  useEffect(() => {
    // Push the current path to history to prevent going back
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      // Prevent the back button
      window.history.pushState(null, '', window.location.href);
    };

    // Listen for the popstate event
    window.addEventListener('popstate', handlePopState);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const isButtonDisabled = !companyUser?.rc || companyUser.rc.length === 0;

  return (
    <Result
      status='404'
      title='No Company Found'
      subTitle={
        isButtonDisabled
          ? 'There is no associated company. Please contact your administrator.'
          : 'You are associated with a company, please press the Back'
      }
      extra={
        <Button
          type='primary'
          onClick={() => navigate(ROUTES.HOME)}
          disabled={isButtonDisabled} // Button is disabled if rc is empty
        >
          {t('errors.404.action')}
        </Button>
      }
    />
  );
};
